type StorageAccessTypes = {
  cookies?: boolean;
  localStorage?: boolean;
  sessionStorage?: boolean;
};

type StorageAccessDocument = Document & {
  requestStorageAccess?: (types?: StorageAccessTypes) => Promise<unknown>;
};

// DESP-144109: add more advanced storage access request for age-verification cookies within iframe (Ploom PWA app)
export async function requestStorageAccessFromUserGesture(): Promise<boolean> {
  if (typeof document === "undefined") {
    return false;
  }

  const doc = document as StorageAccessDocument;

  if (!doc.requestStorageAccess) {
    return false;
  }

  try {
    await doc.requestStorageAccess({
      cookies: true,
      localStorage: true,
      sessionStorage: true,
    });

    return true;
  } catch {
    try {
      // older webkit browsers only support the cookie-only, no-arg signature
      await doc.requestStorageAccess();

      return true;
    } catch {
      return false;
    }
  }
}
